<template>
  <div>
    <TopParallax
      title="BULLETINS & NEWSLETTERS"
      :img-src="imgSrc"
    />
    <bulletin-alert></bulletin-alert>
    <bulletin-info></bulletin-info>
  </div>
</template>

<script>
import TopParallax from '@/components/TopParallax.vue'
import BulletinAlert from '@/components/BulletinAlert.vue'
import BulletinInfo from '@/components/BulletinInfo.vue'

export default {
  components: {
    TopParallax,
    BulletinAlert,
    BulletinInfo
  },
  data() {
    return {
      imgSrc: require('@/assets/images/bulletins_banner.jpg')
    }
  },
  head: {
    title: function () {
      return {
        inner: 'Bulletins'
      }
    }
  }
}
</script>
